import React from 'react';

// FilterLocation is no longer used - location search has been removed.
const FilterLocation = () => null;
export default FilterLocation;
